import { SupabaseJob } from '@applicator/shared'

export function getRelevanceStatus(supabaseJob: SupabaseJob) {
  return {
    isRelevant: supabaseJob.relevance_verdict === 'Fit' || supabaseJob.is_relevant === true,
    isRejected: supabaseJob.rejected_from_relevant === true,
    isNotRelevant: supabaseJob.is_relevant === false,
    isPending: supabaseJob.is_relevant === null || supabaseJob.is_relevant === undefined
  }
}

export function getRelevanceBadgeClasses(isRelevant: boolean, isNotRelevant: boolean): string {
  if (isRelevant) return 'bg-brand-primary text-text-inverse'
  if (isNotRelevant) return 'bg-danger text-text-inverse'
  return 'bg-warning text-text-inverse'
}

export function getRelevanceBadgeText(isRelevant: boolean, isNotRelevant: boolean): string {
  if (isRelevant) return 'Relevant'
  if (isNotRelevant) return 'Not Relevant'
  return 'Analyzing...'
}

export function isJobRejectedFromRelevant(supabaseJob: SupabaseJob | undefined): boolean {
  return supabaseJob?.rejected_from_relevant === true
}

export function isJobRelevantForNext(supabaseJob: SupabaseJob | undefined): boolean {
  return supabaseJob?.relevance_verdict === 'Fit' || supabaseJob?.is_relevant === true
}
